import { locales } from "configs/i18n";
import i18next from "i18next";

i18next.addResources(locales.EN, "EDIT_SHARE", {
  BUTTON_TEXT: "Edit share campaigns",
});
